import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import { StyledButton } from '../../../Components/Generics.styled';

const GenerateLandingPageContainer = styled.div`
    display: flex;
    height: 100%;
    width: 100%;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 23px;
    font-weight: bold;
    margin-top: 80px;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    margin-left: auto;
    margin-right: auto;
    text-align: center;
    margin-bottom: 50px;
`;

const LandingPagePreview = styled.div`
    margin-left: auto;
    margin-right: auto;
    margin-top: 30px;
    width: 100%;
    max-width: 600px;
    text-align: center;
    border: 1px solid black;
`;

const StyledNavButtons = styled.div`
    margin-top: 30px;
    margin-bottom: 30px;
    display: flex;
    justify-content: space-between;
    width: 100%;
    max-width: 180px;
    margin-left: auto;
    margin-right: auto;
`;

const StartBtn = styled(Button)`
    top: 10px;
    background: ${(props) =>
        `${props.primarycolor}  0% 0% no-repeat padding-box` ||
        'green  0% 0% no-repeat padding-box'} !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 20px;
    width: 20px;
    font-size: 8px !important;
    color: #fafbf7;

    &.MuiButton-contained.Mui-disabled {
        color: #fafbf7;
    }
    :disabled {
        background: #9b9b9d 0% 0% no-repeat padding-box !important;
    }
`;

const HeadlineText = styled.div`
    font-size: 12px;
    font-weight: bold;
`;
const Subtext = styled.div`
    font-size: 12px;
`;

const Background = styled.div`
    background-image: ${(props) =>
        `linear-gradient(rgba(255, 255, 255, 0.834), rgba(255, 248, 248, 0.854)), url(${props.backgroundSrc})` ||
        '2px solid blue'};
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    height: 300px;
`;

const Icon = styled.img`
    padding: 16px;
    display: block;
    max-width: 130px;
    max-height: 95px;
    width: auto;
    height: auto;
`;

const Applet = styled.div`
    height: 110px;
    width: 200px;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    background-color: #fafbf7;
    border-radius: 5px;
    box-shadow: 1px 1px 2px #00000059;
`;

const StyledTextField = styled(TextField)`
    top: 10px;
    .MuiOutlinedInput-input {
        padding-top: 0px;
        padding-bottom: 0px;
        padding-left: 8px;
        padding-right: 8px;
    }
`;

const GenerateLandingPage = (props) => {
    const { handleNavButtonBack, saveLandingPage, leadGenerationData, postData, noConfig } = props;

    const [backgroundImageBase64, setBackgroundImageBase64] = useState('');
    const [logoBase64, setLogoBase64] = useState('');

    const setLogoFile = (e) => {
        const reader = new FileReader();
        if (leadGenerationData?.logoFile?.file instanceof Blob) {
            reader.readAsDataURL(leadGenerationData.logoFile.file);
            reader.onload = () => setLogoBase64(reader.result);
            reader.onerror = () => (error) => {
                console.log('Error: ', error);
            };
        }
    };
    const setBackgroundFile = (e) => {
        const reader = new FileReader();
        if (leadGenerationData?.backgroundImageFile?.file instanceof Blob) {
            reader.readAsDataURL(leadGenerationData.backgroundImageFile.file);
            reader.onload = () => setBackgroundImageBase64(reader.result);
            reader.onerror = () => (error) => {
                console.log('Error: ', error);
            };
        }
    };

    useEffect(() => {
        setBackgroundFile();
        setLogoFile();
    }, [leadGenerationData]);

    const generateBtnText = () => {
        if (noConfig) {
            return 'Generate';
        }
        return 'Update';
    };

    return (
        <GenerateLandingPageContainer>
            <Title>Landing Page Preview</Title>
            <LandingPagePreview>
                <Background
                    style={{ backgroundColor: leadGenerationData?.theme?.backgroundImageColor }}
                    backgroundSrc={backgroundImageBase64}
                >
                    <Icon alt="icon" src={logoBase64} />
                    <HeadlineText>{leadGenerationData?.theme?.headline}</HeadlineText>
                    <Subtext>{leadGenerationData?.theme?.subtext}</Subtext>
                    <Applet>
                        <StyledTextField id="sub-text" placeholder="Name" variant="outlined" />
                        <StyledTextField id="sub-text" placeholder="Email" variant="outlined" />
                        <StyledTextField id="sub-text" placeholder="Phone" variant="outlined" />
                        <button
                            style={{
                                backgroundColor: leadGenerationData?.theme?.primaryColor,
                                color: leadGenerationData?.theme?.secondaryColor,
                                fontSize: '8px',
                                marginTop: '15px',
                            }}
                        >
                            Start
                        </button>
                    </Applet>
                </Background>
            </LandingPagePreview>
            <StyledNavButtons>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => handleNavButtonBack()}
                >
                    Back
                </StyledButton>
                <StyledButton
                    variant="contained"
                    color="primary"
                    onClick={() => saveLandingPage()}
                    //   disabled={campaignData.categoryId === ''}
                >
                    {postData?.isLoading ? (
                        <CircularProgress
                            style={{ height: '20px', width: '20px', color: 'white' }}
                            color="primary"
                        />
                    ) : (
                        generateBtnText()
                    )}
                </StyledButton>
            </StyledNavButtons>
            <br />
            <div style={{ color: 'red' }}>
                {' '}
                {postData.error ? `Error: ${postData.errorText}` : ''}
            </div>
        </GenerateLandingPageContainer>
    );
};

GenerateLandingPage.propTypes = {
    handleNavButtonBack: propTypes.func,
    leadGenerationData: propTypes.shape({
        subdomain: propTypes.string,
        theme: propTypes.shape({
            primaryColor: propTypes.string,
            secondaryColor: propTypes.string,
            backgroundImageColor: propTypes.string,
            logoSrc: propTypes.string,
            backgroundImageSrc: propTypes.string,
            headline: propTypes.string,
            subtext: propTypes.string,
        }),

        backgroundImageFile: propTypes.shape({
            file: propTypes.shape({}),
        }),
        logoFile: propTypes.shape({
            file: propTypes.shape({}),
        }),

        questions: propTypes.arrayOf(propTypes.shape({})),
    }),
    saveLandingPage: propTypes.func,
    postData: propTypes.shape({
        isLoading: propTypes.bool,
        error: propTypes.bool,
        errorText: propTypes.string,
    }),
    noConfig: propTypes.bool,
};

GenerateLandingPage.defaultProps = {
    handleNavButtonNext: () => {},
    handleNavButtonBack: () => {},
    leadGenerationData: { logoFile: {} },
    setLeadGenerationData: () => {},
    postData: {
        isLoading: false,
    },
};
export default GenerateLandingPage;
